import React, { useRef, useState } from "react";
import { Upload } from "lucide-react";
import { adminUpload } from "@/lib/adminApi";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const resolve = (url) => {
  if (!url) return "";
  if (url.startsWith("http")) return url;
  return `${BACKEND_URL}${url}`;
};

export default function ImagePicker({ value, onChange, label = "Image", testid = "image" }) {
  const fileRef = useRef(null);
  const [uploading, setUploading] = useState(false);

  const onFile = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setUploading(true);
    try {
      const res = await adminUpload(file);
      onChange(res.url);
    } catch (err) {
      alert("Échec de l'upload");
    }
    setUploading(false);
  };

  return (
    <div className="adm-field">
      <label>{label}</label>
      <div className="img-picker">
        <img className="img-preview" src={resolve(value) || "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg'/%3E"} alt="" />
        <div style={{ flexGrow: 1, display: "flex", flexDirection: "column", gap: "0.5rem" }}>
          <input
            type="text"
            placeholder="/images/... ou https://..."
            value={value || ""}
            onChange={(e) => onChange(e.target.value)}
            data-testid={`${testid}-url`}
          />
          <button type="button" className="adm-btn ghost sm" onClick={() => fileRef.current.click()} disabled={uploading} data-testid={`${testid}-upload`}>
            <Upload size={13} /> {uploading ? "Envoi…" : "Téléverser une image"}
          </button>
          <input ref={fileRef} type="file" accept="image/*" onChange={onFile} style={{ display: "none" }} />
        </div>
      </div>
    </div>
  );
}

export { resolve as resolveImg };
